<template>
  <div class="pb-6">
    <div v-if="loading" class="text-center py-4">
      <div class="spinner-border spinner-border-sm text-secondary" role="status"></div>
    </div>
    <div v-else-if="error" class="section-error">
      <i class="fas fa-circle-exclamation section-error__icon"></i>
      <p class="section-error__text">{{ error }}</p>
      <button class="btn btn-outline-danger btn-sm" @click="$emit('retry-fetch')">
        <i class="fas fa-rotate-right me-1"></i>Tentar novamente
      </button>
    </div>
    <div v-else>
      <!-- Filtro discreto -->
      <div v-if="withdrawals.length > 0" class="filter-chips mb-3">
        <button class="filter-chip" :class="{ active: filter === 'all' }" @click="filter = 'all'">Todos</button>
        <button class="filter-chip" :class="{ active: filter === 'pending' }" @click="filter = 'pending'">Aguardando</button>
        <button class="filter-chip" :class="{ active: filter === 'processing' }" @click="filter = 'processing'">Processando</button>
        <button class="filter-chip" :class="{ active: filter === 'completed' }" @click="filter = 'completed'">Concluído</button>
        <button class="filter-chip" :class="{ active: filter === 'failed' }" @click="filter = 'failed'">Falhou</button>
      </div>

      <div v-if="filteredWithdrawals.length === 0" class="empty-state text-center py-5">
        <i class="fas fa-money-bill-transfer fa-2x text-muted mb-3 d-block"></i>
        <p class="text-muted">{{ filter === 'all' ? 'Nenhum saque realizado ainda.' : 'Nenhum saque com este status.' }}</p>
      </div>
      <div v-else class="d-flex flex-column gap-3">
        <RescueRequestCard
          v-for="w in filteredWithdrawals"
          :key="w.id"
          :request="w"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import RescueRequestCard from '@/components/RescueRequestCard.vue';

const props = defineProps({
  withdrawals: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  error: { type: String, default: '' },
  initialFilter: { type: String, default: 'all' },
});

const emit = defineEmits(['update:filter', 'retry-fetch']);

const filter = ref(props.initialFilter);

watch(filter, (val) => emit('update:filter', val));

const filteredWithdrawals = computed(() => {
  if (filter.value === 'all') return props.withdrawals;
  return props.withdrawals.filter(w => w.status === filter.value);
});
</script>

<style scoped>
.filter-chips { display: flex; flex-wrap: wrap; gap: 0.35rem; }
.filter-chip {
  display: inline-flex; align-items: center; padding: 0.2rem 0.65rem;
  border-radius: 999px; border: 1px solid #e5e7eb; background: #f9fafb;
  color: #6b7280; font-size: 0.7rem; font-weight: 500; line-height: 1.4;
  cursor: pointer; transition: background 0.15s, color 0.15s, border-color 0.15s;
  white-space: nowrap; user-select: none;
}
.filter-chip:hover { background: #f3f4f6; color: #374151; border-color: #d1d5db; }
.filter-chip.active { background: #eff6ff; color: #1d4ed8; border-color: #bfdbfe; font-weight: 600; }
.empty-state i { opacity: 0.4; }
.pb-6 { padding-bottom: 3rem; }

.section-error {
  text-align: center; padding: 2rem 1.5rem; background: #fff;
  border-radius: 16px; border: 1px solid #fecaca;
}
.section-error__icon { font-size: 1.5rem; color: #ef4444; margin-bottom: 0.5rem; }
.section-error__text { font-size: 0.85rem; color: #6b7280; margin-bottom: 0.75rem; }
</style>
